export enum Categorey {
  Body = "Body",
  Head = "Head",
  Torso = "Torso",
  Arms = "Arms",
  Legs = "Legs",
  Tools = "Tools",
  Weapons = "Weapons",
}

export enum Sex {
  Male = "male",
  Female = "female",
  Child = "child",
  Teen = "teen",
  Pregnant = "pregnant",
  Muscular = "muscular",
}

export enum Animations {
  Spellcast = "spellcast",
  Thrust = "thrust",
  Walk = "walk",
  Slash = "slash",
  Shoot = "shoot",
  Hurt = "hurt",
  Watering = "watering",
  Idle = "idle",
  Jump = "jump",
  Run = "run",
  Sit = "sit",
  Emote = "emote",
  Climb = "climb",
  Combat = "combat",
  OneHandSlash = "1h_slash",
  OneHandBackslash = "1h_backslash",
  OneHandHalfslash = "1h_halfslash",
}

// 角色方向枚举
export enum Direction {
  Up = 0,
  Down = 2,
  Left = 1,
  Right = 3,
}
